import { createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "calendar" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["DatePicker"], {
      modelValue: _ctx.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.value) = $event)),
      "max-date": $props.maxDate,
      "min-date": $props.minDate,
      inline: $props.inline,
      "show-icon": false,
      unstyled: false,
      placeholder: $props.placeholder,
      "selection-mode": $props.selectionMode,
      "label-class": "p-inputtext"
    }, {
      default: _withCtx(() => [
        _createCommentVNode(" <template v-slot:dropdownicon>\n      <Icon icon=\"fm dropdown\" heigth=\"2rem\" width=\"2rem\"/>\n    </template> ")
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue", "max-date", "min-date", "inline", "placeholder", "selection-mode"])
  ]))
}